import { useQuery } from "@tanstack/react-query";
import { GetStoresRequest_Sort } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";

import type { ConnectClient } from "../../../libs/api";
import { queryBuilder } from "../../../libs/stores";
import type { GeoLocation } from "../types";

export type UseStoresQueryParams = {
  client: ConnectClient;
  query: {
    name?: string;
    cities: string[];
    categories: string[];
  };
  location?: GeoLocation;
  cities: string[];
  categories: string[];
};

export const useStoresQuery = ({
  client,
  query,
  location,
  cities,
  categories,
}: UseStoresQueryParams) => {
  return useQuery({
    queryKey: ["stores", query, location, cities, categories],
    queryFn: async () => {
      const response = await client.getStores({
        query: queryBuilder({
          query,
          condition: {
            cities,
            categories,
          },
        }),
        location,
        sort: location ? GetStoresRequest_Sort.DISTANCE : undefined,
      });
      return response.stores;
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  });
};
